import React, { Component } from "react"

import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent"

import Constants from "../../../Phi/Constants"

import "./Resources.css"

import iconMinus from "./Assets/icon-minus.svg"
import iconPlus from "./Assets/icon-plus.svg"
import iconLeft from "./Assets/icon-left.svg"
import iconRight from "./Assets/icon-right.svg"
import iconPage from "./Assets/icon-page.svg"
import iconPageBordered from "./Assets/icon-page-bordered.svg"

import { Document, Page, pdfjs } from "react-pdf"
// import "react-pdf/dist/Page/AnnotationLayer.css"
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const DEFAULT_SOP_DOC = "https://hsgbucket.s3.ap-south-1.amazonaws.com/web-resources/public/SOPResources+/SampleSOP.pdf"

class Resources extends Component {
    constructor(props) {
        super(props)

        this.state = {
            numPages: 0,
            pageNumber: 2,

            scale: 1,
            currentPages: 2,

            showToolBox: true,

            time: 0,
            isOn: true,
            start: 0,
        }

        this.startTimer = this.startTimer.bind(this)
        this.stopTimer = this.stopTimer.bind(this)
        this.resetTimer = this.resetTimer.bind(this)
    }

    startTimer() {
        this.setState({
            isOn: true,
            time: this.state.time,
            start: Date.now() - this.state.time,
        })
        this.timer = setInterval(() => {
            this.setState({
                time: Date.now() - this.state.start,
            })

            if (this.state.time > 15000) {
                this.stopTimer()
            }
        }, 2000)
    }
    stopTimer() {
        this.setState({ isOn: false })
        clearInterval(this.timer)
    }
    resetTimer() {
        this.setState({ time: 0, isOn: true })
        this.startTimer()
    }

    componentWillMount() {
        document.addEventListener("mousemove", (event) => {
            if (!this.state.isOn) {
                this.resetTimer()
            }
        })

        this.startTimer()
    }

    componentDidMount(){
        if(window.innerWidth < 767) {
            this.setState({
                pageNumber: 1,
                currentPages: 1
            })
        }
    }

    componentWillUnmount() {}

    componentWillReceiveProps(newProps) {}

    componentDidUpdate(oldProps, oldState) {}

    setNumPages(num, _this) {
        _this.setState({ numPages: num })
    }

    onDocumentLoadSuccess({ numPages }, _this) {
        _this.setNumPages(numPages, _this)
    }

    toolBox = () => {
        let { numPages, pageNumber, scale, currentPages, isOn } = this.state

        pageNumber = parseInt(pageNumber)

        let increment = currentPages, decrement = currentPages

        let allowZoomOut = Boolean(currentPages === 1 && scale > 0.25),
            allowZoomIn = Boolean(currentPages === 1 && scale < 3),


            allowPageDecrease = Boolean((pageNumber - currentPages) > 0),
            allowPageIncrease = Boolean((pageNumber + currentPages) <= numPages),

            pageDecreaseValue =
                pageNumber - currentPages > -1 ? (pageNumber - currentPages === 0 ? currentPages : pageNumber - currentPages === 1 ? 1 : null) : null,
            pageIncreaseValue = numPages - pageNumber + currentPages > 0 && numPages - pageNumber + currentPages < 2 ? 1 : null,

            allowSwitchSingle = !Boolean(currentPages === 1),
            allowSwitchMultiple = !Boolean(currentPages === 2)

            if (pageNumber + currentPages > numPages && pageNumber + 1 === numPages) {
                allowPageIncrease = true
                increment = 1
            }

        return (
            <div className="col-xs-12 padding-0" style={{display: 'flex', justifyContent: 'center'}}>
                <div className={`col-xs-12 hsg-resources-control-root center ${isOn ? "fadeIn" : "fadeOut"}`}>
                    <div className="hsg-resources-control-content">
                        {/* <div className="hsg-resources-control-sub-content">
                        <img
                            className={`hsg-resources-control-internal cursor-pointer ${!allowZoomOut ? "hsg-resources-control-internal-disabled" : ""}`}
                            onClick={() => (allowZoomOut ? this.setState((pState) => ({ scale: allowZoomOut ? pState.scale - 0.25 : pState.scale })) : null)}
                            src={iconMinus}
                        />
                        <span className="hsg-resources-control-internal hsg-resources-control-internal-scale">{`${scale * 100} %`}</span>
                        <img
                            className={`hsg-resources-control-internal cursor-pointer ${!allowZoomIn ? "hsg-resources-control-internal-disabled" : ""}`}
                            onClick={() => (allowZoomIn ? this.setState((pState) => ({ scale: allowZoomIn ? pState.scale + 0.25 : pState.scale })) : null)}
                            src={iconPlus}
                        />
                    </div> */}

                        <div className="hsg-resources-control-sub-content">
                            <img
                                className={`hsg-resources-control-internal cursor-pointer ${
                                    allowPageDecrease ? "" : "hsg-resources-control-internal-disabled"
                                }`}
                                onClick={() =>
                                    allowPageDecrease
                                        ? this.setState((pState) => ({ pageNumber: pState.pageNumber - decrement }))
                                        : null
                                }
                                src={iconLeft}
                            />
                            <span>
                                <input
                                    className="hsg-resources-control-internal hsg-resources-control-internal-scale-input"
                                    value={(pageNumber > 0) ? pageNumber : ""}
                                    onChange={(e) => {
                                        let possibleValue = e.target.value

                                        possibleValue = parseInt(possibleValue)
                                        possibleValue = possibleValue > 0
                                            ? possibleValue > this.state.numPages || possibleValue < 0
                                                ? this.state.pageNumber || 0
                                                : possibleValue
                                            : null

                                        this.setState({ pageNumber: possibleValue })
                                    }}
                                />{" "}
                            </span>
                            <span className="hsg-resources-control-internal hsg-resources-control-internal-scale">{`of ${numPages}`}</span>
                            <img
                                className={`hsg-resources-control-internal cursor-pointer ${
                                    allowPageIncrease ? "" : "hsg-resources-control-internal-disabled"
                                }`}
                                onClick={() =>
                                    allowPageIncrease
                                        ? this.setState((pState) => ({ pageNumber: pState.pageNumber + increment }))
                                        : null
                                }
                                src={iconRight}
                            />
                        </div>

                        <div className="hsg-resources-control-sub-content" style={{ marginTop: 7, display: 'flex' }}>
                            <span
                                className={`hsg-resources-control-internal cursor-pointer`}
                                onClick={() => (allowSwitchMultiple ? this.setState({ currentPages: 2, pageNumber: pageNumber > 1 ? pageNumber : 2 }) : null)}
                            >
                                {!allowSwitchMultiple ? (
                                    <span>
                                        <img height={16} width={16} className="hsg-resources-control-internal-double-page" src={iconPageBordered} />
                                        <img height={16} width={16} className="hsg-resources-control-internal-double-page" src={iconPageBordered} />
                                    </span>
                                ) : (
                                    <span>
                                        <img height={16} width={16} style={{opacity: .6}} className="hsg-resources-control-internal-double-page" src={iconPage} />
                                        <img height={16} width={16} style={{opacity: .6}} className="hsg-resources-control-internal-double-page" src={iconPage} />
                                    </span>
                                )}
                            </span>
                            <span className="" style={{marginTop: 5}}>|</span>
                            <div className="hsg-resources-control-internal cursor-pointer">
                                {!allowSwitchSingle ? (
                                    <img height={16} width={16} className={``} src={iconPageBordered} />
                                ) : (
                                    <img
                                        height={16} width={16}
                                        style={{opacity: .6}}
                                        className={``}
                                        onClick={() => (allowSwitchSingle ? this.setState({ currentPages: 1, pageNumber: pageNumber > 1 ? pageNumber : 1 }) : null)}
                                        src={iconPage}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        let { numPages, pageNumber, scale, currentPages } = this.state

        pageNumber = parseInt(pageNumber)

        return (
            <div className="container-fluid padding-left-0 margin-top-30 margin-bottom-20 center" style={{ minHeight: "95vh" }}>
                <div className="col-xs-12 padding-0">
                    <Document
                        className="hsg-resources-document"
                        file={this.props.organization.SOPResources || DEFAULT_SOP_DOC}
                        onLoadSuccess={(e) => this.onDocumentLoadSuccess(e, this)}
                        // onLoadError={console.error}
                        loading={
                            <div style={{ height: "100%" }}>
                                <Loader blockUI={false} isLoading={true} />
                            </div>
                        }
                        className=""
                        renderMode="canvas"
                        scale={scale}
                    >
                        {currentPages === 1 ? (
                            <div className="col-xs-12 padding-0 center">
                                <div className="col-xs-12 col-md-6" >
                                    <Page className="hsg-resources-page" error={""} scale={scale} pageNumber={pageNumber} />
                                </div>
                            </div>
                        ) : (
                            <div>
                                {!pageNumber ? <div>
                                        <div className="col-xs-6">
                                            <Page className="hsg-resources-page" error={""} scale={scale} pageNumber={1} />
                                        </div>
                                        <div className="col-xs-6">
                                            <Page className="hsg-resources-page" error={""} scale={scale} pageNumber={2} />
                                        </div>
                                    </div> : pageNumber - 1 ? (
                                    <div>
                                        <div className="col-xs-6">
                                            <Page className="hsg-resources-page" error={""} scale={scale} pageNumber={pageNumber - 1} />
                                        </div>
                                        <div className="col-xs-6">
                                            <Page className="hsg-resources-page" error={""} scale={scale} pageNumber={pageNumber} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-xs-12 padding-0 center">
                                        <div className="col-xs-6" style={{ marginLeft: "25%" }}>
                                            <Page className="hsg-resources-page" error={""} scale={scale} pageNumber={pageNumber} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {this.toolBox()}

                        {/* <div style={{height: '100%'}}><Loader blockUI={false} isLoading={true} /> </div> */}
                    </Document>
                </div>
                {/* <div>
                                {this.state.time}
                            </div> */}
                {/* <Countdown date={this.state.startInterval} onComplete={() => this.setState({ showToolBox: false })} /> */}
            </div>
        )
    }
}

export default Resources
